import React from 'react';
import env from 'env';
import { Table } from 'components/table/table';
import utils from 'utils';
import { SiteLink } from 'components';
import { Loading, ErrorPopup, usePost } from 'components';

export function Products(props) {

  const [filters, setFilters] = React.useState({ categoryId: '', status: '' });
  const post = usePost();
  const [filterKeyword, setFilterKeyword] = React.useState(
    window.localStorage.getItem("filterKeyword") || ""
  );

  const changeFilterKeyword = (e) => {
    setFilterKeyword(e.target.value);
    window.localStorage.setItem("filterKeyword", e.target.value);
  };

  function removeFilter() {
    setFilterKeyword("");
    window.localStorage.setItem("filterKeyword", "");
  }
  function filterList(productList) {
    // Ensure productList is an array
    if (!Array.isArray(productList)) {
      return [];
    }
    
    let filtered = productList;
    if (filterKeyword && filterKeyword.trim()) {
      filtered = filtered.filter(
        (x) =>
          searchInField(x.productCode, filterKeyword) ||
          searchInField(x.productName, filterKeyword) ||
          searchInField(x.productUrl, filterKeyword)
      );
    }
    return filtered;
  }

  function searchInField(str, search_str) {
    if (!str || !search_str) return false;
    const result = str.search(new RegExp(escapeRegExp(search_str), "i"));
    return result >= 0;
  }

  function escapeRegExp(str) {
    // eslint-disable-next-line
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  }

  React.useEffect(() => {
    post.send(env.apiBase + `/api/productAdmin/getList`, filters);
    // eslint-disable-next-line
  }, [filters]);

  if (post.loading()) {
    return <Loading />
  } else if (post.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={post.errors} />
  }

  const handChange = (el => {
    const elName = el.target.name;
    const elValue = el.target.value;
    setFilters({ ...filters, [elName]: elValue });
  });

  const data = post.response;
  console.log("data ---- ", data);
  
  // Check if data and productList exist before filtering
  if (!data || !data.productList) {
    return <div>No data available</div>;
  }
  
  const filtered = filterList(data.productList);

  return (
    <>
      <h1>Products</h1>
      <div className="filter editor" style={{ minHeight: '30px', maxWidth:'100%' }}>
        <SiteLink className="btn btn-outline-primary" to="/admin/product/new">Add Product</SiteLink>
        <div className='filter__wrap'>
          <label className='label' style={{ marginLeft: '5px' }}>Product Status </label>
          <select name="status" type="select" value={filters.status} onChange={handChange} className="form-control" style={{ marginRight: '0px' }}>
            <option value=""> All </option>
            {/* <option value="0">Available</option> */}
            {/* <option value="1">Sold Out</option> */}
            <option value="13">Live</option>
            <option value="14">Archived</option>
            <option value="99">Discontinued</option>
            <option value="98">N/A</option>
          </select>
        </div>
        
        <div className='filter__wrap' style={{ marginRight: '1rem' }}>
          <label className='label' style={{ marginLeft: '5px' }}> Search </label>
          <input
            className='form-control'
            type='text'
            placeholder='Search'
            value={filterKeyword}
            onChange={changeFilterKeyword}
            style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
          />
          {filterKeyword && (
            <span
              style={{
                display: "inline-block",
                fontSize: "0.8rem",
                color: "chocolate",
                margin: "5px 0",
                // marginLeft: "10px",
                cursor: "pointer",
              }}
              onClick={removeFilter}
            >
              clear filter
            </span>
          )}
        </div>
        
        <div className='filter__wrap' style={{ marginRight: '1rem' }}>
          <label className='label' style={{ marginLeft: '5px' }}> Category </label>
          <select name="categoryId" type="select" value={filters.categoryId} onChange={handChange} className="form-control" style={{ marginRight: '0px' }}>
            <option value="">All Products</option>
            {
              (data.categoryList || []).map((item, index) => <option key={index} value={item.categoryId}> {item.categoryName} </option>)
            }
          </select>
        </div>

      </div>
      <GetTable data = {filtered} />
    </>
  );
}


function GetTable({ data }) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Product Name',
        accessor: 'productName',
        Cell: (c) => {
          //console.log(c)
          return (<SiteLink to={`/admin/product/${c.row.original.productId}`}><b>{c.cell.value}</b></SiteLink>)
        }
      },
      {
        Header: 'Product Code',
        accessor: 'productCode',
      },
      {
        Header: 'Product Status',
        accessor: 'productStatusText',
      },
      {
        Header: 'Url',
        accessor: 'productSlug',
      },
      {
        Header: 'Price',
        accessor: 'price',
      },
      {
        Header: 'Updated Date',
        accessor: 'dateUpdated',
        Cell: (c) => c.cell.value && utils.date.formatYYYYMMDD(c.cell.value)
      }
    ],
    []
  )

  return (
    <Table columns={columns} data={data} />
  )

}